import {
  Backdrop,
  Box,
  CircularProgress,
  Grid,
  IconButton,
  ListItem,
  Menu,
  MenuItem,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import { Enumerations } from "../../config/Enumerations";
import { CiFileOn } from "react-icons/ci";
import { AppEntryAttachmentRepository } from "../repositories/AppEntryAttachmentRepository";
import React, { useState } from "react";
import PDFDialogViewer from "./PDFDialogViewer";
import { TfiMoreAlt } from "react-icons/tfi";
import { GoEye } from "react-icons/go";
import { FiDownload } from "react-icons/fi";
import { SETTINGS } from "../../Settings";

const options = [
  { key: "download", label: "Преземи", icon: <FiDownload size={18} /> },
];

export default function EntryAttachedDocuments({
  appEntry,
  attachedDocuments,
}) {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [pdfBlob, setPdfBlob] = useState(null);
  const [openPdfDialog, setOpenPdfDialog] = useState(false);
  const [menuAnchor, setMenuAnchor] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [menuOptions, setMenuOptions] = useState([]);
  const [saving, setSaving] = useState(false);

  const getByFileName = (fileName) => {
    AppEntryAttachmentRepository.getDocument(appEntry?.id, fileName, {
      responseType: "blob",
    })
      .then((res) => {
        setPdfBlob(res.data);
        setOpenPdfDialog(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const downloadByFileName = (fileName) => {
    setSaving(true);
    const url = `${SETTINGS.INTERNAL_API_URL}internal/appEntryAttachments/get/${
      appEntry.id
    }/${encodeURIComponent(fileName)}`;

    console.log("Downloading from URL:", url);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setSaving(false);
  };

  const handleMenuClick = (event, fileName) => {
    setMenuAnchor(event.currentTarget);
    setSelectedFile(fileName);

    const filtered = options.filter((option) => {
      if (fileName.toLowerCase().endsWith(".dwg") && option.key === "preview") {
        return false;
      }

      return true;
    });

    setMenuOptions(filtered);
  };

  const handleMenuClose = () => {
    setMenuAnchor(null);
    setSelectedFile(null);
  };

  return (
    <Paper
      elevation={1}
      sx={{ padding: 2, backgroundColor: theme.palette.primary.main }}
    >
      <div className="attached-documents-header">
        <Typography variant="h6" className="header-text">
          Прикачени документи
        </Typography>
      </div>
      <Box className="attached-documents-box">
        {attachedDocuments?.map((attachment, index) => (
          <ListItem key={index} className="document-item light-border">
            <div className="document-icon">
              <CiFileOn color="#fff" size={25} />
            </div>
            <div className="document-details">
              <Typography variant="inherit" className="document-name light">
                {Enumerations.DocumentType[attachment.documentType] ||
                  attachment.type}{" "}
              </Typography>
            </div>
            <div className="document-actions">
              <IconButton
                disableRipple
                aria-label="more"
                id="long-button"
                aria-controls={open ? "long-menu" : undefined}
                aria-expanded={open ? "true" : undefined}
                aria-haspopup="true"
                onClick={(e) => handleMenuClick(e, attachment.fileName)}
              >
                <TfiMoreAlt size={20} color="#fff" />
              </IconButton>
              <Menu
                id="long-menu"
                anchorEl={menuAnchor}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(menuAnchor)}
                onClose={handleMenuClose}
                slotProps={{
                  paper: {
                    style: {
                      width: "20ch",
                      boxShadow:
                        "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
                    },
                  },
                  list: {
                    "aria-labelledby": "long-button",
                  },
                }}
              >
                {menuOptions.map((option) => (
                  <MenuItem
                    key={option.label}
                    selected={option === "Pyxis"}
                    disableRipple
                    onClick={() => {
                      if (option.key === "preview") {
                        getByFileName(selectedFile);
                      } else if (option.key === "download") {
                        downloadByFileName(selectedFile);
                      }
                      handleMenuClose();
                    }}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start",
                      gap: "10px",
                      margin: "1px 5px",
                      borderRadius: "4px",
                      "&:hover": {
                        backgroundColor: "#eaf5ff",
                      },
                    }}
                  >
                    {option.icon}
                    <Typography
                      variant="subtitle2"
                      style={{ fontSize: "14px" }}
                    >
                      {option.label}
                    </Typography>
                  </MenuItem>
                ))}
              </Menu>
            </div>
          </ListItem>
        ))}
      </Box>
      <PDFDialogViewer
        openPdfDialog={openPdfDialog}
        setOpenPdfDialog={setOpenPdfDialog}
        pdfBlob={pdfBlob}
      />
      {saving && (
        <Backdrop open={true} sx={{ zIndex: 9999, color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </Paper>
  );
}
